<template>
    <section>
      <div class="w-full bg-white rounded-md mt-2 p-4">
        <div class="w-full flex gap-2 items-center">
          <i class="pi pi-list"></i>
          <p class="text-lg font-bold">Listado de tasa Sub Anual</p>
          <Button @click="displayModalTasa = true, idTasa = null" class="ml-auto rounded-md" label="Crear Tasa" />
        </div>
        <div class="grid grid-cold-1 md:grid-cols-2 lg:grid-cols-5 gap-2 my-2">
          <!-- filtro por cod -->
          <div class="w-full flex flex-col">
            <label class="text-xs text-gray-600 mt-1" for="cod">Año</label>
            <!-- <InputText class="w-full" id="cod" @keyup.enter="listarTasa" v-model="filtros.U_PHR_Regimen" /> -->
            <Dropdown v-model="filtros.Anio" id="cod" :options="anios" optionLabel="name" optionValue="value"
                  placeholder="Seleccione un tipo"/>
          </div>
          <!-- filtro por nombre -->
          <div class="w-full">
            <label class="text-xs text-gray-600" for="desc">Régimen</label>
            <InputText class="w-full" id="desc" @keyup.enter="listarTasa" v-model="filtros.U_PHR_RangSalarial"/>
          </div>
          <div class="flex gap-2">
            <Button @click="listarTasa" class="mt-5 mb-1.5 rounded-md" label="Buscar" />
            <Button @click="limpiarFiltros" class="mt-5 mb-1.5 rounded-md p-button-outlined p-button-secondary" label="Limpiar" />
          </div>
        </div>
        <div class="w-full my-2">
          <DataTable class="p-datatable-sm text-xs" :value="cuotas.rows" responsiveLayout="scroll">
            <Column header="Año">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ data.Anio }}</p>
                  <div class="flex gap-x-4 hover:text-blue-600 text-white transition ease-in-out duration-500">
                    <button class="underline italic" @click='EditTasa(data.Id)'>Editar</button>
                  </div>
                </div>
              </template>
            </Column>
            <Column field="Code" header="Cod"></Column>
            <Column header="Regimen">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ data.U_PHR_Regimen == 'S' ? 'Subsidiado' : 'Contributivo' }}</p>
                </div>
              </template>
            </Column>
            <Column header="Rango sal.">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ data.U_PHR_RangSalarial }}</p>
                </div>
              </template>
            </Column>
            <Column header="% cobro">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ Math.round(data.U_PHR_PorCobro,0) }} %</p>
                </div>
              </template>
            </Column>
            <Column header="Mx Nivel">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ helper.formatCurrency(Math.round(data.U_PHR_TpMxNivel,0)) }}</p>
                </div>
              </template>
            </Column>
            <Column header="Valor Cuota">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ helper.formatCurrency(Math.round(data.U_PHR_ValorCuota,0)) }}</p>
                </div>
              </template>
            </Column>
            <Column header="Tope Maximo">
              <template #body="{data}">
                <div class=" pt-3">
                  <p>{{ helper.formatCurrency(Math.round(data.U_PHR_TopeMaxRango,0)) }}</p>
                </div>
              </template>
            </Column>

            <Column header="Acción">
              <template #body="{data}">
                <div class="p-2 rounded-md text-center" >
                  <Button
                      @click='DeleteTasa(data.Id)'
                      severity="danger"
                      v-tooltip="'Eliminar'"
                      class='p-button-rounded p-button-icon-only mx-2'
                  >
                    <i class="pi pi-trash text-white"></i>
                  </Button>
                </div>
              </template>
            </Column>
          </DataTable>
          <Paginator v-model:first="offset"
            :rows="limit"
            :totalRecords="parseInt(cuotas.count)"
            :rowsPerPageOptions="[2,10,20,30,100]"
            @page="onPage($event)"
          />
        </div>
      </div>
      <Dialog :header="`${idTasa ? 'Actualizar' : 'Crear'} Tasa`" v-model:visible="displayModalTasa" :breakpoints="{'960px': '95vw'}" :style="{width: '60vw'}" :modal="true">
        <div class="grid gap-4 bg-white dark:bg-dark-1 dark:text-gray-500 w-full sm:grid-cols-2 lg:grid-cols-5 xl:grid-cols-5 xxl:grid-cols-5">
          <div class="sm:col-span-2 lg:col-span-5 xl:col-span-5 xxl:col-span-5">
            <crearTasa @crearTasa="displayModalTasa = false, listarTasa()" :idTasa="idTasa" />
          </div>
        </div>
      </Dialog>
      <Toast />
    </section>
</template>
<script setup>
  import { useToast } from 'primevue/usetoast'
  import Swal from 'sweetalert2'
  import TasaService from '../../../../../services/calculo-cuota.service'
  import { onMounted, ref, computed } from 'vue'
  import crearTasa from './crear.vue'
  import { helper } from '@/utils/helper'
    // name: 'ListadoDiagnosticos'
    // Servicios
    const toast = useToast()
    const _TasaService = ref(new TasaService())
    // Referencias
    const cuotas = ref([])
    const limit = ref(10)
    const offset = ref(0)
    const filtros = ref({
      U_PHR_Regimen: null,
      U_PHR_RangSalarial: null
    })
    const idTasa = ref(null)
    const displayModalTasa = ref(false)
    const anios = []
    const params = computed(() => {
      return {
        limit: limit.value,
        offset: offset.value,
        ...filtros.value
      }
    })
    // Metodos
    const onPage = ({ first, page, pageCount, rows }) => {
      limit.value = rows
      listarTasa(params.value)
    }
    const listarTasa = () => {
      const object = {
        ...params.value,
        limit: limit.value,
        offset: offset.value
      }
      _TasaService.value.paginate(object).then(({ data }) => {
        cuotas.value = data
      })
    }
    const EditTasa = (id) => {
      displayModalTasa.value = true
      idTasa.value = id
    }
    // const RangoSal = (ran) => {
    //   switch (ran) {
    //     case 'NI':
    //       return 'Nivel 1'
    //     case 'NII':
    //       return 'Nivel 2'
    //     case 'NIII':
    //       return 'Nivel 2'
    //     case 'R1':
    //       return 'Rango 1'
    //     case 'R2':
    //       return 'Rango 2'
    //     case 'R3':
    //       return 'Rango 2'
    //     default:
    //       return ''
    //   }
    // }
    const DeleteTasa = (id) => {
      Swal.fire({
          title: 'Esta seguro de eliminar esta Tasa?',
          showDenyButton: true,
          denyButtonText: 'Cancelar',
          confirmButtonText: 'Eliminar'
        }).then((result) => {
          if (result.isConfirmed) {
            _TasaService.value.eliminarTasa(id).then(({ data }) => {
              if (data.error) {
                console.error('Error al eliminar la Tasa, por favor intente nuevamente')
              } else {
                toast.add({ severity: 'success', summary: 'Exito', detail: 'Tasa eliminada exitosamente', life: 3000 })
              }
              listarTasa()
            })
          } else if (result.isDenied) {
            Swal.fire('Tasa no eliminada', '', 'info')
          }
        })
    }
    const limpiarFiltros = () => {
      filtros.value = {
        U_PHR_Regimen: null,
        U_PHR_RangSalarial: null
      }
      listarTasa()
    }
    onMounted(() => {
      listarTasa()
    })
</script>
<style>
  .p-dropdown-label{
    font-size: 0.75rem !important
  }
  .tipoId .p-dropdown-trigger {
    display: none !important;
  }
  ::-webkit-scrollbar-thumb {
    background: rgb(189, 189, 189);
    border-radius: 9999px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
  ::-webkit-input-placeholder { /* Edge */
    color: gray;
  }
  ::-webkit-scrollbar {
    width: 0.4rem;
  }
</style>
